import styled from "styled-components"
import DataTable_s from "components/table/data-table-styles"
import { Colors } from "styles/app-styles"

export const ReportTags_s = styled.div`
  .p-paginator {
    bottom: 0px;
  }
`

export const AuditLogTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  margin-top: -35px;

  .p-paginator {
    bottom: 0px;
  }

  svg {
    height: 16px;
    padding-top: 4px;
    padding-right: 3px;

    .r-svg {
      fill: ${Colors.blackPearl};
      height: 100%;
    }
  }

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  .p-datatable-scrollable-header {
    overflow: visible;
  }

  .p-datatable-scrollable-body {
    padding-top: 72px;
  }

  .p-datepicker.p-component.p-connected-overlay-enter-done {
    background: white;
    border: 1px solid gray;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  .p-datatable-tbody > tr > td {
    padding-left: 15px;
  }

  .p-column-filter-date-group {
    display: flex;
    > span {
      margin-right: 10px;
      > .p-calendar {
        width: 211px;
        margin-bottom: 5px;
      }
    }
  }

`